const mutations = {
  ["automativeOptionBoxFlagActions"](state, payload) {
    state.isAutomativeOptionOn = payload;
  },
  ["BankingSectorOptionBoxFlagActions"](state, payload) {
    state.isBankingSectorOptionOn = payload;
  },
  ["CreditCardSectorOptionBoxFlagActions"](state, payload) {
    state.isCreditSectorOptionOn = payload;
  },
  ["SECTORDROPDOWNDATAAPI"](state, payload) {
    state.rawSectorAutomativeData = payload;
  },
  ["SECTORCATEGORYDROPDOWNDATAAPI"](state, payload) {
    // console.log("mutu ", payload);
    let x = payload.sort((a, b) => (a.name > b.name ? 1 : -1));

    state.categorySectorData = x;
  },
  ["SECTORSUBCATEGORYDATAMUT"](state, payload) {
    // console.log("mutu ", payload);
    let x = payload.sort((a, b) => (a.name > b.name ? 1 : -1));
    // console.log(x, "x");
    state.subCategorySectorData = x;
  },
  ["CategoryFieldsCleaningMUT"](state, payload) {
    // console.log("mutu ", payload);
    state.categoryFieldsCleaning = payload;
  },
  ["SECTORSUBSUBCATEGORYDATAMUT"](state, payload) {
    // console.log("mutu ", payload);
    let x = payload.sort((a, b) => (a.name > b.name ? 1 : -1));
    state.subSubCategorySectorData = x;
  },
  ["PRODUCTNAMEOPENMUT"](state, payload) {
    // console.log("mutu ", payload);
    state.productName = payload;
  },
  ["BankingCardActionMut"](state, payload) {
    // console.log("mutu auto ", payload);
    state.BankingCard = payload;
  },
  ["CreditComboBoxesMut"](state, payload) {
    // console.log("mutu auto ", payload);
    state.CreditComboBoxes = payload;
  },
  ["EnergyBoxesFlagMut"](state, payload) {
    // console.log("mutu auto ", payload);
    state.energyBoxesFlag = payload;
  },
  ["SectorEDCEnergyDataMut"](state, payload) {
    // console.log("mutu auto ", payload);
    state.SectorEDCEnergyData = payload;
  },
  ["SectorIdsCommMut"](state, payload) {
    if (payload > 0) {
      if (typeof payload !== "string") {
        state.sectorIdComm.push(payload);
      } else {
        state.sectorIdComm[0].audience.push(payload);
      }
    } else {
      if (payload === -1) {
        state.sectorIdComm = [{ audience: [] }];
      } else {
        state.sectorIdComm.splice(1);
      }
    }
    if (
      state.sectorIdComm[0].audience.length === 0 &&
      state.sectorIdComm.length === 0
    ) {
      state.SectorCommData = [];
    }
    // state.sectorIdComm.push(payload);
  },
  ["CommunicationTypeData"](state, payload) {
    let communication_type = state.orignalCommuncationCopied;
    let commTypeLocal = [];
    if (payload.status === "select") {
      if (payload.sleBox !== "audience") {
        state.sectorIDs.push(payload.id);
      } else {
        state.audienceIDs.push(payload.id);
      }

      for (let i = 0; i < communication_type.length; i++) {
        if (communication_type[i].sector_id) {
          for (let j = 0; j < state.sectorIDs.length; j++) {
            let status = communication_type[i].sector_id
              .split(",")
              .includes(state.sectorIDs[j].toString());
            if (status) {
              commTypeLocal.push(communication_type[i]);
            }
          }
        }
        if (communication_type[i].audience_id !== null) {
          for (const k in state.audienceIDs) {
            let status = communication_type[i].audience_id
              .split(",")
              .includes(state.audienceIDs[k].toString());
            if (status) {
              commTypeLocal.push(communication_type[i]);
            }
          }
        }
      }
      const uniqueCommunicationData = [
        ...new Set(commTypeLocal.map((item) => item)),
      ];
      // console.log("payload.", uniqueCommunicationData);
      state.SectorCommData = uniqueCommunicationData;
    } else if (payload.status === "dis") {
      const findID = (e) => e === payload.id;
      if (payload.sleBox === "sector") {
        if (payload.id === -1) {
          state.sectorIDs = [];
        } else {
          let indValue = state.sectorIDs.findIndex(findID);
          if (indValue !== -1) {
            state.sectorIDs.splice(indValue, 1);
          }
        }
      } else {
        if (payload.id === -1) {
          state.audienceIDs = [];
        } else {
          let indValue = state.audienceIDs.findIndex(findID);
          if (indValue !== -1) {
            state.audienceIDs.splice(indValue, 1);
          }
        }
      }

      for (let i = 0; i < communication_type.length; i++) {
        if (communication_type[i].sector_id) {
          for (let j = 0; j < state.sectorIDs.length; j++) {
            let status = communication_type[i].sector_id
              .split(",")
              .includes(state.sectorIDs[j].toString());
            if (status) {
              commTypeLocal.push(communication_type[i]);
            }
          }
        }
        if (communication_type[i].audience_id !== null) {
          for (const k in state.audienceIDs) {
            let status = communication_type[i].audience_id
              .split(",")
              .includes(state.audienceIDs[k].toString());
            if (status) {
              commTypeLocal.push(communication_type[i]);
            }
          }
        }
      }
      const uniqueCommunicationData = [
        ...new Set(commTypeLocal.map((item) => item)),
      ];
      state.SectorCommData = uniqueCommunicationData;
    }
  },
  ["SectorCommDataMut"](state, payload) {
    console.log("pay", payload);
    state.SectorCommData = payload;
  },
  ["SectorAllIdsMut"](state, payload) {
    // console.log("pay", payload);
    state.sectorAllIds = payload;
  },
  ["MortageSelectedMut"](state, payload) {
    // console.log("pay", payload);
    state.mortgageSelectedFlag = payload;
  },
  ["responseMechanismMut"](state, payload) {
    // console.log("pay", payload);
    state.responseMechanism = payload;
  },
  ["categorySelectedMut"](state, payload) {
    // console.log("pay", payload);
    state.CategorySelected = payload;
  },
  ["subcategorySelectedMut"](state, payload) {
    // console.log("catselected", payload);
    state.subCategorySelected = payload;
  },
  ["subSubcategorySelectedMut"](state, payload) {
    // console.log("pay", payload);
    state.subSubCategorySelected = payload;
  },
  ["responseMechanismAPIMut"](state, payload) {
    // console.log("pay", payload);
    state.responseMechanismAPI = payload;
  },
  ["rangeSliderAPIMut"](state, payload) {
    // console.log("pay", payload);
    state.rangeSlider = payload;
  },
  ["InsuranceBoxFlagMut"](state, payload) {
    // console.log(payload, "pay ins");
    state.insuranceBoxFlag = payload;
  },
  ["InvestmentBoxFlagMut"](state, payload) {
    state.investmentBoxFlag = payload;
  },
  ["TravelRetailBoxFlagMut"](state, payload) {
    state.retailTravelFlag = payload;
  },
  ["sectorIdsRidersDataMut"](state, payload) {
    state.sectorIdRidersData = payload;
  },
  ["SectorFaceAmtDataMut"](state, payload) {
    state.sectorFaceAmtData = payload;
  },
  ["SectorIssueTypeDataMut"](state, payload) {
    state.sectorIssueTypeData = payload;
  },
  ["CheckboxPayloadSet"](state, payload) {
    // console.log("CCCCC", payload);
    switch (payload.value) {
      case "Worksite/Voluntary":
        if (payload.status) {
          state.checkboxPayload["worksite_voluntary"] = "1";
          state.checkboxPayloadCopy["worksite_voluntary"] = "1";
        } else {
          delete state.checkboxPayload.worksite_voluntary;
          delete state.checkboxPayloadCopy.worksite_voluntary;
        }
        break;
      case "Non-Worksite/Voluntary":
        if (payload.status) {
          state.checkboxPayload["worksite_voluntary"] = "0";
          state.checkboxPayloadCopy["worksite_voluntary"] = "0";
        } else {
          delete state.checkboxPayload.worksite_voluntary;
          delete state.checkboxPayloadCopy.worksite_voluntary;
        }
        break;
      case "Credit Union":
        if (payload.status) {
          state.checkboxPayload["is_credit_union"] = "1";
          state.checkboxPayloadCopy["is_credit_union"] = "1";
        } else {
          delete state.checkboxPayload.is_credit_union;
          delete state.checkboxPayloadCopy.is_credit_union;
        }
        break;
      case "Non-Credit Union":
        if (payload.status) {
          state.checkboxPayload["is_credit_union"] = "0";
          state.checkboxPayloadCopy["is_credit_union"] = "0";
        } else {
          delete state.checkboxPayload.is_credit_union;
          delete state.checkboxPayloadCopy.is_credit_union;
        }
        break;
      case "Affinity/Association":
        if (payload.status) {
          state.checkboxPayload["affinity_association"] = "1";
          state.checkboxPayloadCopy["affinity_association"] = "1";
        } else {
          delete state.checkboxPayload.affinity_association;
          delete state.checkboxPayloadCopy.affinity_association;
        }
        break;
      case "Non-Affinity/Association":
        if (payload.status) {
          state.checkboxPayload["affinity_association"] = "0";
          state.checkboxPayloadCopy["affinity_association"] = "0";
        } else {
          delete state.checkboxPayload.affinity_association;
          delete state.checkboxPayloadCopy.affinity_association;
        }
        break;

      //lvl 2 start
      case "Pre-Screen/Opt-Out":
        if (payload.status) {
          state.checkboxPayload["is_prescreen"] = "1";
          state.checkboxPayloadCopy["is_prescreen"] = "1";
        } else {
          delete state.checkboxPayload.is_prescreen;
          delete state.checkboxPayloadCopy.is_prescreen;
        }
        break;
      case "Non-Pre-Screen/Opt-Out":
        if (payload.status) {
          state.checkboxPayload["is_prescreen"] = "0";
          state.checkboxPayloadCopy["is_prescreen"] = "0";
        } else {
          delete state.checkboxPayload.is_prescreen;
          delete state.checkboxPayloadCopy.is_prescreen;
        }
        break;
      case "Retail Card Study":
        if (payload.status) {
          state.checkboxPayload["is_citi"] = "1";
          state.checkboxPayloadCopy["is_citi"] = "1";
        } else {
          delete state.checkboxPayload.is_citi;
          delete state.checkboxPayloadCopy.is_citi;
        }
        break;
      case "Non-Retail Card Study":
        if (payload.status) {
          state.checkboxPayload["is_citi"] = "0";
          state.checkboxPayloadCopy["is_citi"] = "0";
        } else {
          delete state.checkboxPayload.is_citi;
          delete state.checkboxPayloadCopy.is_citi;
        }
        break;
      case "Fee Product":
        if (payload.status) {
          state.checkboxPayload["Fee_Product"] = "1";
          state.checkboxPayloadCopy["Fee_Product"] = "1";
        } else {
          delete state.checkboxPayload.Fee_Product;
          delete state.checkboxPayloadCopy.Fee_Product;
        }
        break;
      case "Ancillary Service - No Fee":
        if (payload.status) {
          state.checkboxPayload["Fee_Product"] = "0";
          state.checkboxPayloadCopy["Fee_Product"] = "0";
        } else {
          delete state.checkboxPayload.Fee_Product;
          delete state.checkboxPayloadCopy.Fee_Product;
        }
        break;
      case "Rewards":
        if (payload.status) {
          state.checkboxPayload["rewards_program"] = "1";
          state.checkboxPayloadCopy["rewards_program"] = "1";
        } else {
          delete state.checkboxPayload.rewards_program;
          delete state.checkboxPayloadCopy.rewards_program;
        }
        break;
      case "Refinance":
        if (payload.status) {
          state.checkboxPayload["refinance"] = "1";
          state.checkboxPayloadCopy["refinance"] = "1";
        } else {
          delete state.checkboxPayload.refinance;
          delete state.checkboxPayloadCopy.refinance;
        }
        break;
      case "Non-Refinance":
        if (payload.status) {
          state.checkboxPayload["refinance"] = "0";
          state.checkboxPayloadCopy["refinance"] = "0";
        } else {
          delete state.checkboxPayload.refinance;
          delete state.checkboxPayloadCopy.refinance;
        }
        break;
      //Level 1
      case "Incentive":
        if (payload.status) {
          state.checkboxPayload["is_incentive"] = "1";
          state.checkboxPayloadCopy["is_incentive"] = "1";
        } else {
          delete state.checkboxPayload.is_incentive;
          delete state.checkboxPayloadCopy.is_incentive;
        }
        break;
      case "Rx":
        if (payload.status) {
          state.checkboxPayload["prescription"] = "1";
          state.checkboxPayloadCopy["prescription"] = "1";
        } else {
          delete state.checkboxPayload.prescription;
          delete state.checkboxPayloadCopy.prescription;
        }
        break;
      case "Affinion":
        if (payload.status) {
          state.checkboxPayload["is_affinion"] = "1";
          state.checkboxPayloadCopy["is_affinion"] = "1";
        } else {
          delete state.checkboxPayload.is_affinion;
          delete state.checkboxPayloadCopy.is_affinion;
        }
        break;
      case "CreditCardMentioned":
        if (payload.status) {
          state.checkboxPayload["r_credit_card_mentioned"] = "1";
          state.checkboxPayloadCopy["r_credit_card_mentioned"] = "1";
        } else {
          delete state.checkboxPayload.r_credit_card_mentioned;
          delete state.checkboxPayloadCopy.r_credit_card_mentioned;
        }
        break;
      case "TargetMarkets":
        if (payload.status) {
          state.checkboxPayload["target_market_id"] = "1";
          state.checkboxPayloadCopy["target_market_id"] = "1";
          state.checkboxPayload["null_search"] = "target_market_id,notnull";
          state.checkboxPayloadCopy["null_search"] = "target_market_id,notnull";
        } else {
          delete state.checkboxPayload.target_market_id;
          delete state.checkboxPayloadCopy.target_market_id;
        }
        break;
      case "Jumbo/Non-Conforming":
        if (payload.status) {
          state.checkboxPayload["jumbo_ncnfg"] = "1";
          state.checkboxPayloadCopy["jumbo_ncnfg"] = "1";
        } else {
          delete state.checkboxPayload.jumbo_ncnfg;
          delete state.checkboxPayloadCopy.jumbo_ncnfg;
        }
        break;
      case "VA":
        if (payload.status) {
          state.checkboxPayload["va"] = "1";
          state.checkboxPayloadCopy["va"] = "1";
        } else {
          delete state.checkboxPayload.va;
          delete state.checkboxPayloadCopy.va;
        }
        break;
      case "FHA":
        if (payload.status) {
          state.checkboxPayload["fha"] = "1";
          state.checkboxPayloadCopy["fha"] = "1";
        } else {
          delete state.checkboxPayload.fha;
          delete state.checkboxPayloadCopy.fha;
        }
        break;
      case "Conventional":
        if (payload.status) {
          state.checkboxPayload["conventional"] = "1";
          state.checkboxPayloadCopy["conventional"] = "1";
        } else {
          delete state.checkboxPayload.conventional;
          delete state.checkboxPayloadCopy.conventional;
        }
        break;
      case "USDA":
        if (payload.status) {
          state.checkboxPayload["usda"] = "1";
          state.checkboxPayloadCopy["usda"] = "1";
        } else {
          delete state.checkboxPayload.usda;
          delete state.checkboxPayloadCopy.usda;
        }
        break;
      case "Correspondent Lending":
        if (payload.status) {
          state.checkboxPayload["correspondent_lending"] = "1";
          state.checkboxPayloadCopy["correspondent_lending"] = "1";
        } else {
          delete state.checkboxPayload.correspondent_lending;
          delete state.checkboxPayloadCopy.correspondent_lending;
        }
        break;
      case "FauxCheck":
        if (payload.status) {
          state.checkboxPayload["faux_check"] = "1";
          state.checkboxPayloadCopy["faux_check"] = "1";
        } else {
          delete state.checkboxPayload.faux_check;
          delete state.checkboxPayloadCopy.faux_check;
        }
        break;

      //lvl3 hidden one
      case "Primary":
        if (payload.status) {
          state.checkboxPayload["primary_only"] = "sector_id";
        } else {
          delete state.checkboxPayload.primary_only;
          state.checkboxPayload = state.checkboxPayloadCopy;
        }
        break;
      case "Not":
        if (payload.status) {
          // state.checkboxPayload["agent_communication_id"] = "1";
          state.checkboxPayload["nots0"] = "agent_communication_id(null)";
        } else {
          delete state.checkboxPayload.agent_communication_id;
          delete state.checkboxPayload.nots0;
          state.checkboxPayload = state.checkboxPayloadCopy;
        }
        break;
      case "Not1":
        if (payload.status) {
          state.checkboxPayload["nots1"] = "mtype_id";
          state.checkboxPayloadCopy["nots1"] = "mtype_id";
        } else {
          delete state.checkboxPayload.nots1;
          delete state.checkboxPayloadCopy.nots1;
        }
        break;
      case "Reloadable":
        if (payload.status) {
          state.checkboxPayload["is_reloadable"] = "1";
          state.checkboxPayloadCopy["is_reloadable"] = "1";
        } else {
          delete state.checkboxPayload.is_reloadable;
          delete state.checkboxPayloadCopy.is_reloadable;
        }
        break;
      case "CDHP/HDHP/HSA":
        if (payload.status) {
          state.checkboxPayload["is_hphsa"] = "1";
          state.checkboxPayloadCopy["is_hphsa"] = "1";
        } else {
          delete state.checkboxPayload.is_hphsa;
          delete state.checkboxPayloadCopy.is_hphsa;
        }
        break;
      case "delete_mortage_selected":
        delete state.checkboxPayload.refinance;
        delete state.checkboxPayloadCopy.refinance;
        delete state.checkboxPayload.jumbo_ncnfg;
        delete state.checkboxPayloadCopy.jumbo_ncnfg;
        delete state.checkboxPayload.va;
        delete state.checkboxPayloadCopy.va;
        delete state.checkboxPayload.fha;
        delete state.checkboxPayloadCopy.fha;
        delete state.checkboxPayload.conventional;
        delete state.checkboxPayloadCopy.conventional;
        delete state.checkboxPayload.usda;
        delete state.checkboxPayloadCopy.usda;
        delete state.checkboxPayload.correspondent_lending;
        delete state.checkboxPayloadCopy.correspondent_lending;
        break;
      case "delete_travel_retailbox_flaghandler":
        delete state.checkboxPayload.r_credit_card_mentioned;
        delete state.checkboxPayloadCopy.r_credit_card_mentioned;
        break;
      case "delete_credit_card":
        delete state.checkboxPayload.is_reloadable;
        delete state.checkboxPayloadCopy.is_reloadable;
        break;
      case "delete_insurance":
        delete state.checkboxPayload.is_hphsa;
        delete state.checkboxPayloadCopy.is_hphsa;
        break;
      case "delete_rewards":
        delete state.checkboxPayload.rewards_program;
        delete state.checkboxPayloadCopy.rewards_program;
        break;
    }
    // console.log("EEEe..State", state.checkboxPayload);
    // console.log("Copied", state.checkboxPayloadCopy);
  },
  ["TargetIDs"](state, payload) {
    state.targetIds = payload;
    // console.log("Aaaa", state.targetIds);
    // state.targetIds = [];
    // state.targetIds.push(payload);
  },
  ["DeliveryMethodId"](state, payload) {
    // console.log("DeliveryMethodId.", payload);
    state.delivery_method_id = payload;
  },

  ["DeliveryTypeId"](state, payload) {
    state.delivery_type_id = payload;
  },
  ["PackageTypeId"](state, payload) {
    state.package_type_id = payload;
  },
  ["PresortedId"](state, payload) {
    state.presorted_id = payload;
  },
  ["PostageId"](state, payload) {
    state.postage_id = payload;
  },
  ["categoryPayloadMut"](state, payload) {
    // console.log(payload, "catpayload");
    Object.keys(state.categoryPayload).find((key) => {
      // console.log(key, "key");
      if (key === "cat_") {
        let ind = state.categoryPayload[key].findIndex((f) => f == payload);
        if (ind === -1) {
          state.categoryPayload[key].push(payload);
        } else {
          state.categoryPayload[key].splice(ind, 1);
        }
        // console.log(ind, "ind");
      }
    });
  },
  ["unCheckcategoryPayloadMut"](state, payload) {
    Object.keys(state.categoryPayload).find((key) => {
      if (key === "cat_") {
        if (state.categoryPayload[key].includes(payload)) {
          const index = state.categoryPayload[key].indexOf(payload);
          if (index >= 0) {
            state.categoryPayload[key].splice(index, 1);
          }
        }
      }
    });
  },
  ["subcategoryPayloadMut"](state, payload) {
    // console.log(payload, "subcatpayloadmut");
    Object.keys(state.categoryPayload).find((key) => {
      if (key === "cat_sub") {
        // console.log(state.categoryPayload[key], "key");
        // console.log(typeof state.categoryPayload[key], "key");
        let ind = state.categoryPayload[key].findIndex((f) => f == payload);
        if (ind === -1) {
          state.categoryPayload[key].push(payload);
        } else {
          state.categoryPayload[key].splice(ind, 1);
        }
      }
    });
  },
  ["unCheckSubcategoryPayloadMut"](state, payload) {
    Object.keys(state.categoryPayload).find((key) => {
      if (key === "cat_sub") {
        if (state.categoryPayload[key].includes(payload)) {
          const index = state.categoryPayload[key].indexOf(payload);
          if (index >= 0) {
            state.categoryPayload[key].splice(index, 1);
          }
        }
      }
    });
  },
  ["subsubcategoryPayloadMut"](state, payload) {
    // console.log(payload, "subsubcatpayload");
    Object.keys(state.categoryPayload).find((key) => {
      if (key === "cat_ssub") {
        // const uniqueSet = new Set(state.categoryPayload[key]);
        // // for (const element of payload) {
        // uniqueSet.add(payload);
        // // }
        // state.categoryPayload[key] = uniqueSet;

        let ind = state.categoryPayload[key].findIndex((f) => f == payload);
        if (ind === -1) {
          state.categoryPayload[key].push(payload);
        } else {
          state.categoryPayload[key].splice(ind, 1);
        }
      }
    });
  },
  ["unCheckSubSubcategoryPayloadMut"](state, payload) {
    Object.keys(state.categoryPayload).find((key) => {
      if (key === "cat_ssub") {
        if (state.categoryPayload[key].includes(payload)) {
          const index = state.categoryPayload[key].indexOf(payload);
          if (index >= 0) {
            state.categoryPayload[key].splice(index, 1);
          }
        }
      }
    });
  },
  ["EnergySetPayload"](state, payload) {
    switch (payload.boxname) {
      case "EDC / LDC / TDSP":
        if (state.energyBoxesFlag) {
          if (payload.values.length > 0) {
            state.energySelPayload["edc_id"] = payload.values.toString();
          } else {
            delete state.energySelPayload.edc_id;
          }
        } else {
          delete state.energySelPayload.edc_id;
        }
        break;
      case "Energy - Rate Type":
        if (state.energyBoxesFlag) {
          if (payload.values.length > 0) {
            state.energySelPayload["e_rate_type"] = payload.values.toString();
          } else {
            delete state.energySelPayload.e_rate_type;
          }
        } else {
          delete state.energySelPayload.e_rate_type;
        }
        break;
      case "Offer Price (¢ per kWh)":
        if (state.energyBoxesFlag) {
          if (payload.values.length > 0) {
            let cent = payload.values;
            cent = cent.join(";");
            cent = cent.replaceAll("¢", "").replaceAll(" - ", ",");
            cent = cent.replaceAll(/[a-z]/g, "").replace(/\s\s/g, ",");
            cent = cent
              .split(";")
              .sort(function (a, b) {
                if (parseFloat(a) < parseFloat(b)) {
                  return -1;
                }
                if (parseFloat(a) > parseFloat(b)) {
                  return 1;
                }
                return 0;
              })
              .join(";");
            state.energySelPayload["e_offer_price"] = cent;
            // console.log("energyOfferPrice...", state.energySelPayload);
            state.energySelPayload["range_search"] = "e_offer_price";
          } else {
            delete state.energySelPayload.e_offer_price;
            delete state.energySelPayload.range_search;
          }
        } else {
          delete state.energySelPayload.e_offer_price;
          delete state.energySelPayload.range_search;
        }
        break;
      case "Energy - Term Length":
        if (state.energyBoxesFlag) {
          if (payload.values.length > 0) {
            state.energySelPayload["e_term_length"] = payload.values.toString();
          } else {
            delete state.energySelPayload.e_term_length;
          }
        } else {
          delete state.energySelPayload.e_term_length;
        }
        break;
      case "CancelFee":
        if (payload.status) {
          state.energySelPayload["e_cancel_fee"] = "1";
        } else {
          delete state.energySelPayload.e_cancel_fee;
        }
        break;
      default:
        delete state.energySelPayload.e_offer_price;
        delete state.energySelPayload.e_term_length;
        delete state.energySelPayload.e_cancel_fee;
        delete state.energySelPayload.e_rate_type;
        delete state.energySelPayload.edc_id;
        delete state.energySelPayload.range_search;
        break;
    }
    // console.log("@!!", state.energySelPayload);
  },
  ["SiDropDown"](state, payload) {
    // state.siDropDownPayload = payload;
    // console.log(payload, "sidrop");
    switch (payload.boxname) {
      case "Mailing Type":
        if (payload.values.length > 0) {
          state.siDropDownPayload["mtype_id"] = payload.values.toString();
        } else {
          delete state.siDropDownPayload.mtype_id;
        }
        break;
      case "DMA®":
        if (payload.values.length > 0) {
          state.siDropDownPayload["dma_code"] = payload.values.toString();
        } else {
          delete state.siDropDownPayload.dma_code;
        }
        break;
      case "Age":
        if (payload.values.length > 0) {
          state.siDropDownPayload["age_id"] = payload.values.toString();
        } else {
          delete state.siDropDownPayload.age_id;
        }
        break;
      case "Business Content":
        if (payload.values.length > 0) {
          state.siDropDownPayload["business_content"] =
            payload.values.toString();
        } else {
          delete state.siDropDownPayload.business_content;
        }
        break;
      case "VantageScore":
        if (payload.values.length > 0) {
          state.siDropDownPayload["vantage_range_id"] =
            payload.values.toString();
        } else {
          delete state.siDropDownPayload.vantage_range_id;
        }
        break;
      case "Riders":
        if (payload.values.length > 0) {
          state.siDropDownPayload["rider_id"] = payload.values.toString();
        } else {
          delete state.siDropDownPayload.rider_id;
        }
        break;
      case "Face Amount":
        if (payload.values.length > 0) {
          state.siDropDownPayload["face_id"] = payload.values.toString();
        } else {
          delete state.siDropDownPayload.face_id;
        }
        break;
      case "Income":
        if (payload.values.length > 0) {
          state.siDropDownPayload["income_id"] = payload.values.toString();
        } else {
          delete state.siDropDownPayload.income_id;
        }
        break;
      case "Income Producing Assets Segment Code *R*":
        if (payload.values.length > 0) {
          state.siDropDownPayload["income_producing_assets_segment_code"] =
            payload.values.toString();
        } else {
          delete state.siDropDownPayload.income_producing_assets_segment_code;
        }
        break;
      case "Value Score":
        if (payload.values.length > 0) {
          state.siDropDownPayload["valuescore_for_household"] =
            payload.values.toString();
        } else {
          delete state.siDropDownPayload.valuescore_for_household;
        }
        break;
      case "Offer Origin":
        // console.log(typeof payload.values, "vl");
        if (typeof payload.values === "number") {
          state.siDropDownPayload["offer_origin_id"] =
            payload.values.toString();
        } else {
          delete state.siDropDownPayload.offer_origin_id;
        }
        break;
      case "Application Type":
        if (payload.values.length > 0) {
          state.siDropDownPayload["application_type"] =
            payload.values.toString();
        } else {
          delete state.siDropDownPayload.application_type;
        }
        break;
      case "FicoScore":
        if (payload.values.length > 0) {
          state.siDropDownPayload["fico_range_id"] = payload.values.toString();
        } else {
          delete state.siDropDownPayload.fico_range_id;
        }
        break;
      case "CreditVision":
        if (payload.values.length > 0) {
          state.siDropDownPayload["creditvision_range_id"] = payload.values;
        } else {
          delete state.siDropDownPayload.creditvision_range_id;
        }
        break;
      case "State/Province":
        if (payload.values.length > 0) {
          state.siDropDownPayload["state_id"] = payload.values.toString();
        } else {
          delete state.siDropDownPayload.state_id;
        }
        break;
      case "Communication Type":
        // console.log("finalCommData....X", payload.values);
        if (payload.values.length > 0) {
          state.siDropDownPayload["agent_communication_id"] =
            payload.values.toString();
        } else {
          delete state.siDropDownPayload.agent_communication_id;
        }
        break;
      case "Term Length":
        if (payload.values.length > 0) {
          state.siDropDownPayload["term_id"] = payload.values.toString();
        } else {
          delete state.siDropDownPayload.term_id;
        }
        break;
      case "delete_consumer_box":
        delete state.siDropDownPayload.business_content;
        delete state.siDropDownPayload.dma_code;
        delete state.siDropDownPayload.age_id;
        delete state.siDropDownPayload.income_id;
        delete state.siDropDownPayload.income_producing_assets_segment_code;
        delete state.siDropDownPayload.valuescore_for_household;
        delete state.siDropDownPayload.face_id;
        delete state.siDropDownPayload.term_id;
        break;
      case "delete_insurance_box":
        delete state.siDropDownPayload.rider_id;
        break;
      case "delete_credit_combo":
        delete state.siDropDownPayload.application_type;
        break;
      case "delete_audit_insurance":
        delete state.siDropDownPayload.mtype_id;
        break;
    }
    // console.log("DDDDd", state.siDropDownPayload);
  },
  ["DefaultDropdown"](state, payload) {
    console.log(payload, "payload");
    switch (payload.boxname) {
      case "Ancillary Products":
        if (payload.values.length > 0) {
          state.defaultDropDownData["ancillary_product_id"] =
            payload.values.toString();
        } else {
          delete state.defaultDropDownData.ancillary_product_id;
        }

        break;
      case "Response Mechanism":
        if (payload.values.length > 0) {
          state.defaultDropDownData["response_mechanism_id"] =
            payload.values.toString();
        } else {
          delete state.defaultDropDownData.response_mechanism_id;
        }

        break;
      case "Card Network":
        if (payload.values.length > 0) {
          state.defaultDropDownData["card_network"] = payload.values.toString();
        } else {
          delete state.defaultDropDownData.card_network;
        }
        break;
      case "Campaign Language":
        if (payload.values !== 0) {
          state.defaultDropDownData["language_id"] = payload.values.toString();
        } else {
          delete state.defaultDropDownData.language_id;
        }
        break;
      case "Offer Origin":
        if (payload.values !== 0) {
          state.defaultDropDownData["oo_id"] = payload.values.toString();
        } else {
          delete state.defaultDropDownData.oo_id;
        }
        break;
    }
  },
  ["SectorIdOfferOrigin"](state, payload) {
    state.sectorIdOfferOriginData = payload;
  },
  ["LoanAmount"](state, payload) {
    if (payload.length !== 0) {
      // console.log(Number(payload[0]), 22, Number(payload[1]));
      state.loanAmount.min = Number(payload[0]);
      state.loanAmount.max = Number(payload[1]);
      state.loanAmount.changeHappen = true;
    } else {
      state.loanAmount.changeHappen = false;
      state.loanAmount.min = 0;
      state.loanAmount.max = 0;
    }
  },
  ["AffinityCategories"](state, payload) {
    // console.log("Mutation", payload);
    switch (payload.label) {
      case "affinityCatSelection":
        if (payload.values.length > 0) {
          let affinityIds = [];
          payload.values.forEach((e) => {
            affinityIds.push(e.AffinityCategoryID);
          });
          state.affinityCategory["affinity_category"] = affinityIds.toString();
        } else {
          delete state.affinityCategory.affinity_category;
          delete state.affinityCategory.affinity_sub_category;
        }
        break;
      case "affinitySubCatSelection":
        if (payload.values.length > 0) {
          let affinityIds = [];
          payload.values.forEach((e) => {
            affinityIds.push(e.AffinityCategoryID);
          });
          state.affinityCategory["affinity_sub_category"] =
            affinityIds.toString();
        } else {
          delete state.affinityCategory.affinity_sub_category;
        }
        break;
      case "rewardsProgVariable":
        // console.log(
        //   payload.values,
        //   payload.values.toString(),
        //   "cnvtr",
        //   payload.values.length,
        //   "len"
        // );
        if (payload.values.length > 0) {
          state.affinityCategory["rewards_program_emphasis"] =
            payload.values.toString();
        } else {
          delete state.affinityCategory.rewards_program_emphasis;
          // delete state.checkboxPayload.rewards_program;
        }
        break;
    }
    // console.log("SSSS", state.affinityCategory);
  },
  ["DropDownSetValues"](state, payload) {
    // console.log(payload, "payload");
    switch (payload.id) {
      case 1:
        state.dropDownData.energyRateType = [];
        state.dropDownData.energyRateType.push(...payload.value);
        // console.log("DropDownSetValues", state.dropDownData.energyRateType);
        break;
      case 2:
        state.dropDownData.dma = [];
        state.dropDownData.dma.push(...payload.value);
        // console.log("DropDownSetValues.dma", state.dropDownData.dma);
        break;
      case 3:
        state.dropDownData.cscanEdc = [];
        state.dropDownData.cscanEdc.push(...payload.value);
        // console.log("DropDownSetValues", state.dropDownData.cscanEdc);
        break;
      case 4:
        state.dropDownData.incomeProducing = [];
        state.dropDownData.incomeProducing.push(...payload.value);
        // console.log("incomeProducing", state.dropDownData.incomeProducing);
        break;
      case 5:
        state.dropDownData.scoreHousehold = [];
        state.dropDownData.scoreHousehold.push(...payload.value);
        // console.log("scoreHousehold", state.dropDownData.scoreHousehold);
        break;
      case 6:
        state.dropDownData.etermLength = [];
        state.dropDownData.etermLength.push(...payload.value);
        // console.log("scoreHousehold", state.dropDownData.etermLength);
        break;
    }
  },
  ["SetOrRemoveTermLength"](state, payload) {
    let a = null;
    if (payload === true) {
      for (let i = 10; i <= 50; i += 5) {
        a += 1;
        state.termLenghtData.push({ name: `${i} year`, id: a });
      }
    }
    // console.log(state.termLenghtData, "state.termLenghtData");
  },
  ["BankCreditAction"](state, payload) {
    state.setBankCreditAction = payload;
  },
  ["AllCategorySetMut"](state, payload) {
    state.allSectors = payload;
  },
  ["AllCategoryLocalMut"](state, payload) {
    state.allSectorsLocal = payload;
  },
  ["AllSubCategoryLocalMut"](state, payload) {
    state.allSubSectorsLocal = payload;
  },
  ["AllSubSubCategoryLocalMut"](state, payload) {
    state.allSubSubSectorsLocal = payload;
  },
  ["SelectAllFlagMut"](state, payload) {
    state.selectAllFlag = payload;
  },
  ["OrignalCommuncationCopiedMut"](state, payload) {
    state.orignalCommuncationCopied = payload;
  },
  ["selectedDataMut"](state, payload) {
    // console.log("mut pay", payload);
    if (Object.keys(state.selectedData).length !== 0) {
      let statekeys = [];
      for (let i = 0; i < Object.keys(state.selectedData).length; i++) {
        statekeys = Object.keys(state.selectedData);
      }
      // console.log(statekeys, "keys");
      for (let i = 0; i < Object.keys(state.selectedData).length; i++) {
        let key = Object.keys(payload);
        let value = Object.values(payload);
        console.log(state.selectedData, "taa");
        if (key == "categoryID") {
          if (statekeys.includes(key.toString())) {
            if (
              state.selectedData[key][i].categoryID !== payload[key].categoryID
            ) {
              // state.selectedData.push;
              state.selectedData[key].push(...value);
              // console.log(value, "t");
            }
          } else {
            let mediacopy = {};
            mediacopy = Object.values(payload);
            // console.log(JSON.parse(JSON.stringify(innerObj)), "val");
            state.selectedData[key] = JSON.parse(JSON.stringify(mediacopy));
          }
          // console.log(payload[key], "t");
          // console.log(state.selectedData[key][i].mChannelName, "iii");
        }
        if (key == "subCategoryID") {
          // console.log(payload[key], "t");
          if (statekeys.includes(key.toString())) {
            if (
              state.selectedData[key][i].subCategoryID !==
              payload[key].subCategoryID
            ) {
              // state.selectedData.push;
              state.selectedData[key].push(...value);
              // console.log(value, "t");
            }
          } else {
            let sectorcopy = {};
            sectorcopy = Object.values(payload);
            // console.log(JSON.parse(JSON.stringify(innerObj)), "val");
            state.selectedData[key] = JSON.parse(JSON.stringify(sectorcopy));
          }
          // if (state.selectedData[key][i].sectorID !== payload[key].sectorID) {
          //   // state.selectedData.push;
          //   state.selectedData[key].push(...value);
          //   // console.log(value, "t");
          //}
        }
        if (key == "subSubCategoryID") {
          // console.log(payload[key], "t");
          // console.log(state.selectedData, "taaa", i, key.toString());
          if (statekeys.includes(key.toString())) {
            if (state.selectedData[key][i] !== undefined) {
              if (
                state.selectedData[key][i].subSubCategoryID !==
                payload[key].subSubCategoryID
              ) {
                state.selectedData[key].push(...value);
              }
            }
          } else {
            let audiencecopy = {};
            audiencecopy = Object.values(payload);
            state.selectedData[key] = JSON.parse(JSON.stringify(audiencecopy));
          }

          // if (state.selectedData[key][i].sectorID !== payload[key].sectorID) {
          //   // state.selectedData.push;
          //   state.selectedData[key].push(...value);
          //   // console.log(value, "t");
          //}
        }
      }
    } else {
      let key = Object.keys(payload);
      if (key == "categoryID") {
        let mediacopy = {};
        mediacopy = Object.values(payload);
        // console.log(JSON.parse(JSON.stringify(innerObj)), "val");
        state.selectedData[key] = JSON.parse(JSON.stringify(mediacopy));
      }
      if (key == "subCategoryID") {
        let sectorcopy = {};
        sectorcopy = Object.values(payload);
        // console.log(JSON.parse(JSON.stringify(innerObj)), "val");
        state.selectedData[key] = JSON.parse(JSON.stringify(sectorcopy));
      }
      if (key == "subSubCategoryID") {
        let sectorcopy = {};
        sectorcopy = Object.values(payload);
        // console.log(JSON.parse(JSON.stringify(innerObj)), "val");
        state.selectedData[key] = JSON.parse(JSON.stringify(sectorcopy));
      }
    }
    // console.log(state.selectedData, "state.selectedData");
  },
  ["LastSearchActivated"](state, payload) {
    state.iSLastSearchFlag = payload;
  },
  ["categoriesParents"](state, payload) {
    let key = Object.keys(payload);
    if (key.toString() === "cat") {
      state.categoriesParents[key].push(payload[key]);
    } else if (key.toString() === "subcat") {
      state.categoriesParents[key].push(payload[key]);
    } else if (key.toString() === "subsubcat") {
      state.categoriesParents[key].push(payload[key]);
    }
  },
};
export default mutations;
